import { useLocation, useParams } from "react-router-dom"

import { OWNER } from "modules/Call/common/constants"

function useGetBookingHash(): string | undefined
function useGetBookingHash(throwOnMissing: boolean): string
function useGetBookingHash(throwOnMissing?: boolean): string | undefined | never {
    const { bookingHash } = useParams<{ bookingHash?: string }>()
    if (!bookingHash && throwOnMissing) {
        throw new Error("Booking hash missing")
    }
    return bookingHash
}

function useGetOwner(): OWNER | undefined
function useGetOwner(throwOnMissing: true): OWNER
function useGetOwner(throwOnMissing?: boolean): OWNER | undefined {
    const location = useLocation()
    const owner = location.pathname.split("/")[1]
    switch (owner) {
        case "my":
            return OWNER.Client
        case "psychologist-account":
            return OWNER.Psychologist
        default:
            if (throwOnMissing) throw "Owner not detected"
    }
}

export { useGetBookingHash, useGetOwner }

export function createClientCallPath(path: `/${string}`) {
    return `/my/call${path}`
}

export function createPsyCallPath(path: `/${string}`) {
    return `/psychologist-account/call${path}`
}

export function createInternalCallPath(path: `/${string}`) {
    return `/internal/call${path}`
}

export function getCallRouterPath(path: `/${string}`) {
    return `/:owner(my|psychologist-account|internal)/call${path}`
}
